/**
 * Input DTO interface for updating user data within an organization context.
 * This interface represents the expected payload structure for organization user updates,
 * where nested objects are represented by their MongoDB IDs as strings.
 */
export interface IUserOrganizationUpdateInputDto {
    email?: string;
    firstName?: string;
    lastName?: string;
    locale?: string;
    phone?: string;
    avatar?: string;
    settings?: Record<string, unknown>;
    address?: string;
    /**
     * Array of organization IDs (MongoDB ObjectIds as strings)
     * Note: This should contain the user's organization memberships
     */
    organizations?: string[];
    /**
     * Array of application IDs (MongoDB ObjectIds as strings)
     * Note: These represent the applications the user has access to within the organization
     */
    applications?: string[];
    /**
     * Array of role IDs (MongoDB ObjectIds as strings)
     * Note: These represent the roles assigned to the user within the organization
     */
    roles?: string[];
    /**
     * Array of permission IDs (MongoDB ObjectIds as strings)
     * Note: Direct permissions assigned to the user (if supported)
     */
    permissions?: string[];
    /**
     * The current organization ID
     */
    currentOrganization?: string;
    disabledReason?: string;
}

/**
 * Helper type to extract MongoDB ID from objects that have an id property
 */
export type ExtractId<T extends { id: string }> = T['id'];

/**
 * Helper type to extract MongoDB IDs from an array of objects
 */
export type ExtractIds<T extends { id: string }[]> = ExtractId<T[number]>[];
